import { jsx as _jsx } from "react/jsx-runtime";
import { Icon as DSIcon } from '../../../Icon/Icon';
import { useClassName } from '../../../../hooks';
import './Icon.scss';
export const Icon = () => {
    const className = useClassName({ name: 'input-icon', prefixed: true });
    return (_jsx("div", { "data-testid": 'input-component-end-icon', className: className, children: _jsx(DSIcon, { name: 'chevron-down', size: 'sm', color: 'black' }) }));
};
